import { IEventCollectionDataActiveEvents, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  collectionId: string
  page: number
}

type Response = { data: IEventCollectionDataActiveEvents; metadata: IEventCollectionMetadata }

export const getEvents = async (props: Props): Promise<Response> => {
  const { collectionId, page } = props

  const endpoint = ApiEndpoint.v4.eventCollection.events(collectionId, page)

  const { data, metadata } = await HttpRequestForApiV4.get<IEventCollectionDataActiveEvents, IEventCollectionMetadata>(
    endpoint
  )

  return { data, metadata }
}
